<template>
  <el-card
    id="counterCard"
    shadow="hover"
    class="clear-card counter"
  >
    <div class="title defaultCursor">
      {{ $t(label) }}
      <el-tooltip
        v-if="tooltip"
        effect="dark"
        placement="top"
        :content="tooltip"
      >
        <i class="el-icon-info"></i>
      </el-tooltip>
    </div>
    <div class="data">
      <CountTo
        :start-val="0"
        :end-val="value"
        :suffix="suffix"
        :duration="3000"
      />
    </div>
  </el-card>
</template>

<script>
import CountTo from 'vue-count-to';

export default {
  components: {
    CountTo,
  },

  props: {
    value: {
      type: Number,
      default: 0,
    },
    label: {
      type: String,
      default: '',
    },
    suffix: {
      type: String,
      default: '',
    },
    tooltip: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
  #counterCard {
    text-align: center;

    .data {
      font-size: 35px;
      font-weight: bold;
      padding-top: 15px;
    }
  }
</style>
